import { getPropClassesFromInstance } from 'lib/getPropClasses';
import PropTypes from 'prop-types';
import * as React from 'react';
import ReactSlider from 'react-slider';
import cx from 'classnames';
import './styles/Slider.scss';

/**
 * ## A styled slider built using [React Slider](https://github.com/mpowaga/react-slider).
 * ### Allows the user to select a value on a numeric scale.
 *
 * ```example
 * <Slider
 *   min={0}
 *   max={100}
 *   value={50}
 *   size="thick"
 *   theme="light"
 * />
 * ```
 *
 * ```example
 * <div style={{ background: '#000000', padding: 20 }}>
 *   <Slider
 *     min={0}
 *     max={100}
 *     step={10}
 *     value={0}
 *     size="thin"
 *     theme="dark"
 *   />
 * </div>
 * ```
 *
 *
 * # TODO
 * * Default `size`
 * * Default `theme`
 */

class Slider extends React.Component<any> {
  static propTypes = {
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    step: PropTypes.number,
    value: PropTypes.number.isRequired,
    size: PropTypes.oneOf(['thick', 'thin']).isRequired,
    theme: PropTypes.oneOf(['light', 'dark']).isRequired,
    onBeforeChange: PropTypes.func,
    onChange: PropTypes.func,
    onAfterChange: PropTypes.func,
  };

  static propClasses = {
    size: {
      thick: 'Slider--thick',
      thin: 'Slider--thin',
    },
    theme: {
      dark: 'Slider--dark',
      light: 'Slider--light',
    },
  };

  static defaultProps = {
    step: 1,
  };

  componentDidUpdate(prevProps: any) {
    if (this._slider && this.props.max !== prevProps.max) {
      // @ts-ignore
      this._slider._handleResize();
    }
  }
  _slider: React.Component<ReactSlider.ReactSliderProps, any, any> | null = null;

  render() {
    const { max, min, step, value, onAfterChange, onBeforeChange, onChange } = this.props;

    return (
      <ReactSlider
        min={min}
        max={max}
        step={step}
        value={value}
        orientation="horizontal"
        ref={c => {
          this._slider = c;
        }}
        withBars
        className={cx('Slider', getPropClassesFromInstance(this))}
        onBeforeChange={onBeforeChange}
        onChange={onChange}
        onAfterChange={onAfterChange}
      />
    );
  }
}

export default Slider;
